'use strict';
const angular = require('angular');

/*@ngInject*/
export function SettingsService($resource) {
  return $resource('/api/settings/:id', {
    name: '@_id'
  },{
    getByName: {
      method: 'GET',
        url: "/api/settings/name/:name"
    },
    update: {
      method: 'PUT'
    },
    getLDAPDB: {
      method: 'GET',
      url: "/api/integrations/ldapdb"
    },
    rebuildLDAPB: {
      method: 'GET',
      url: "/api/integrations/rebuild-ldapdb"
    }
  });
}


export default angular.module('conduu.SettingsService', [])
  .factory('SettingsService', SettingsService)
  .name;



// WEBPACK FOOTER //
// ./client/components/settings/settings.service.js